import qs from 'qs'

/**
 * Сериализация фильтров в query string
 * - массивы → key[]=a&key[]=b
 * - дефолты пропускаются
 * @param filters Карта установленных фильтров
 * @param defaults Карта дефолтных фильтров
 */
export const serializeFiltersToUrl = (
    filters: Record<string, any>,
    defaults: Record<string, any> = {}
): string => {
    const filtered: Record<string, any> = {}
    for (const [k, v] of Object.entries(filters)) {
        if (v === undefined || v === null || v === '') continue
        if (defaults && isEqual(v, (defaults as any)[k])) continue
        filtered[k] = v
    }

    return qs.stringify(filtered, {
        arrayFormat: 'brackets', // делает key=A&key[]=B
        encode: false,           // [] не будет превращаться в %5B%5D
    })
}

/**
 * Парсинг query string с поддержкой алиасов
 * @param defaults объект с дефолтами
 * @param aliases карта старых ключей: { oldKey: newKey }
 */
export const parseFiltersFromUrl = <T extends object>(
    defaults: T,
    aliases: Record<string, string> = {}
): T => {
    const raw = qs.parse(window.location.search, {
        ignoreQueryPrefix: true, // убирает '?'
        allowDots: true,         // поддерживает user.name
    })

    const parsed: Record<string, any> = {}
    for (const [key, value] of Object.entries(raw)) {
        const normalizedKey = aliases[key] || key

        if (Array.isArray(value)) parsed[normalizedKey] = value.map(v => normalizeValue(v))
        else parsed[normalizedKey] = normalizeValue(value)
    }

    return { ...defaults, ...parsed } as T
}


/** Конвертирует строковые значения в типы */
function normalizeValue(value: any): any {
    if (typeof value !== 'string') return value
    if (value === 'true') return true
    if (value === 'false') return false
    if (/^-?\d+(\.\d+)?$/.test(value)) return Number(value)
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value)) return new Date(value)
    return value
}

/** Глубокое сравнение */
const isEqual = (a: any, b: any): boolean => {
    if (a === b) return true
    if (a instanceof Date && b instanceof Date) return a.toISOString() === b.toISOString()
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false
        for (let i = 0; i < a.length; i++) if (!isEqual(a[i], b[i])) return false
        return true
    }
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        const ka = Object.keys(a), kb = Object.keys(b)
        if (ka.length !== kb.length) return false
        for (const k of ka) if (!isEqual(a[k], b[k])) return false
        return true
    }
    return false
}